<template>
	<MonacoEditor
		:value="computedValue"
		@change="onChange"
		:language="language"
		theme="vs-dark"
		style="width:100%; min-height:300px;"
		:options="editorOptions"
	/>
</template>

<script>
import JSpinner from "@/components/JSpinner"

const MonacoEditor = () => ({
	component: import("vue-monaco"),
	loading: JSpinner
})

export default {
	components: {
		MonacoEditor,
		JSpinner
	},

	props: {
		language: {
			type: String,
			default: () => "json"
		},
		value: {
			type: String
		},
		readOnly: {
			type: Boolean,
			default: () => false
		}
	},

	data() {
		return {
			editorOptions: {
				autoIndent: true,
				automaticLayout: true,
				autoClosingBrackets: true,
				formatOnPaste: false,
				formatOnType: false,
				tabCompletion: true,
				readOnly: this.readOnly
			}
		}
	},

	methods: {
		onChange(value) {
			this.$emit("input", value === "" ? null : value)
		}
	},

	computed: {
		computedValue() {
			return this.value === null ? "" : this.value
		}
	}
}
</script>

<style>
.monaco-editor {
	padding-top: 5px;
	padding-bottom: 5px;
}
</style>